import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { useSeller } from "../../providers/users";
import Loading from "../Loading";
import { Container } from "./styles";
import { useInvoice } from "../../providers/invoices";

interface IProps {
  setModalChangeStatus: React.Dispatch<React.SetStateAction<boolean>>;
  defaultStatus: string;
  invoice_id: string;
  isAdminView: boolean;
}

const ModalChangeInvoiceStatus = ({
  setModalChangeStatus,
  defaultStatus,
  invoice_id,
  isAdminView,
}: IProps) => {
  const { updateInvoice } = useInvoice();
  const [status, setStatus] = useState(defaultStatus);
  const { apiLoading } = useSeller();
  const { t } = useTranslation();
  const formSchema = yup
    .object()
    .shape({
      status: yup.string().required(t("status_required")),
    })
    .required();

  const handleChangePhase = (event: any) => {
    setStatus(event.target.value);
  };
  const { register, handleSubmit } = useForm({
    resolver: yupResolver(formSchema),
  });

  type FormValues = yup.InferType<typeof formSchema>;
  const onSubmit = async (data: FormValues) => {
    const updated = await updateInvoice(invoice_id, data, isAdminView);
    if (updated) {
      setModalChangeStatus(false);
    }
  };
  return (
    <Container>
      <div className="modalContainer">
        <span>
          <button
            className="exitModalPassword"
            onClick={() => {
              setModalChangeStatus(false);
            }}
          >
            X
          </button>
        </span>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <InputLabel sx={{ mt: 1 }} id="demo-simple-select-label">
              {t("status")}
            </InputLabel>
            <Select
              sx={{ mt: 1 }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={status}
              label={t("status")}
              {...register("status")}
              onChange={handleChangePhase}
            >
              <MenuItem value={"not_applicable"}>
                {t("not_applicable")}
              </MenuItem>
              <MenuItem value={"in_progress"}>{t("in_progress")}</MenuItem>
              <MenuItem value={"concluded"}> {t("concluded")}</MenuItem>
            </Select>
          </FormControl>
          {apiLoading ? (
            <Loading />
          ) : (
            <Button sx={{ mt: 2 }} variant="contained" type="submit">
              {t("update")}
            </Button>
          )}
        </form>
      </div>
    </Container>
  );
};

export default ModalChangeInvoiceStatus;
